export const getTagColor = (isDeactivated?: boolean): string => {
  return !isDeactivated ? "green" : "red"
}
